import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import MHeader from '@/components/ui/organisms/MHeader';
import { getMemberInfo } from '@/hooks/useMembers';
import MTabs, { MTabsKey } from '@/components/ui/atoms/MTabs';
import UploadProgress from './UploadProgress';
import UncategorizedDocuments from './UncategorizedDocuments';
import DocumentLogListing from './DocumentLogListing';
import { MToastProvider } from '@/components/ui/atoms/MToastProvider';

const AllUploads: React.FC = () => {
  const memberInfo = getMemberInfo();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const state = (location.state || {}) as { initialTab?: MTabsKey };
  
  // Read tab from URL params or state, fallback to 'in-progress'
  const tabFromUrl = searchParams.get('tab') as MTabsKey | null;
  const initialTab = tabFromUrl || state.initialTab || 'in-progress';
  const [activeTab, setActiveTab] = React.useState<MTabsKey>(initialTab);
  
  // Update URL when tab changes
  const handleTabChange = (newTab: MTabsKey) => {
    setActiveTab(newTab);
    navigate(`/documents/all-uploads?tab=${newTab}`, { replace: true });
  };

  const items = React.useMemo(
    () => [
      { key: 'in-progress', label: 'In progress' },
      { key: 'uncategorised', label: 'Uncategorised' },
      { key: 'all-uploads', label: 'All uploads' },
    ],
    []
  );

  const renderContent = () => {
    if (activeTab === 'in-progress') {
      return (
        <MToastProvider>
          <UploadProgress />
        </MToastProvider>
      );
    }
    if (activeTab === 'uncategorised') {
      return <UncategorizedDocuments />;
    }
    return <DocumentLogListing />;
  };

  return (
    <div style={{ padding: '0 24px' }}>
      <MHeader
        title="All uploads"
        module="documents"
        memberInfo={memberInfo}
      />

      <div style={{ marginBottom: 16 }}>
        <MTabs items={items} value={activeTab} onChange={handleTabChange} />
      </div>

      {renderContent()}
    </div>
  );
};

export default AllUploads;
